function t(l) {
  return l == null || l.value == null ? null : "$el" in l.value ? l.value.$el : l.value;
}

export { t as dom };